import React from 'react';
import { toast } from 'react-hot-toast';

// Entregar un PDF (28-oct-2026). El celular solo deja descargar dentro de ~5 s del toque: si el PDF tardó
// más (fotos con datos móviles), la descarga se bloqueaba sin aviso y había que tocar dos veces. Si el toque
// ya "venció", queda un aviso con el botón Descargar (un toque nuevo, que el celular sí deja).
export function guardarPDF(doc, fileName) {
    const isIOS = /ipad|iphone|ipod/i.test(navigator.userAgent);
    const entregar = () => {
        if (isIOS) window.open(doc.output('datauristring'), '_blank');
        else doc.save(fileName);
    };
    const activo = navigator.userActivation ? navigator.userActivation.isActive : true;
    if (activo) { entregar(); return; }
    toast((t) => React.createElement('span', { style: { display: 'flex', alignItems: 'center', gap: 12 } },
        React.createElement('span', null, 'PDF listo'),
        React.createElement('button', {
            type: 'button', 'aria-label': `Descargar ${fileName}`,
            onClick: () => { toast.dismiss(t.id); entregar(); },
            style: { background: '#C9341F', color: '#fff', fontWeight: 900, borderRadius: 10, padding: '10px 16px', border: 0 },
        }, 'Descargar')), { duration: 20000, id: 'pdf-listo' });
}
